import React, { useState, useEffect } from "react";
import { DayCampPageOptions } from "../Constants/RegistrationPageOptions";
import '../Styles/DayCampOptions.scss';

function DayCampOptions({ buddyFirstName, setBuddyFirstName, buddyLastName, setBuddyLastName,
   camperSignature, setCamperSignature, setCamperSignatureDate, setSelectedPage, previousPage, nextPage }) {

   var currentDate = new Date().toLocaleDateString();
   const [emptyCamperSignatureError, setEmptyCamperSignatureError] = useState(false)

   function ValidateDayCampOptions() {
      let isError = false

      if (camperSignature === "") {
         setEmptyCamperSignatureError(true)
          isError = true;
      }

      if (isError === false) {
         setSelectedPage(nextPage)
      }
   }
   return (
         <div className="DayCampOptionsContent">
            <form>
               <div className="DayCampOptionsHeading">
                  Day Camp Options
               </div>
               <div className="DayCampOptionsInformation">
                  <div className="DayCampOptionsBuddyInformation">
                     <div className="DayCampOptionBuddyInformationHeading">
                        Buddy Selection
                     </div>
                     <div className="DayCampOptionsBuddyInformationExplanation">
                        Each camper may request one friend of the same gender to share the same group. Request must be mutual from both campers.
                     </div>
                     <div className="DayCampOptionsBuddyInformationFields">
                        <div className="DayCampOptionsBuddyInformationFirstName">
                           <label>Buddy First Name</label>
                           <input
                              type="text"
                              value={buddyFirstName}
                              onChange={(event) => setBuddyFirstName(event.target.value)}
                           />
                        </div>
                        <div className="DayCampOptionsBuddyInformationLastName">
                           <label>Buddy Last Name</label>
                           <input
                              type="text"
                              value={buddyLastName}
                              onChange={(event) => setBuddyLastName(event.target.value)}
                           />
                        </div>
                     </div>
                  </div>
                  <div className="DayCampOptionsCamperSignature">
                     <div className="DayCampOptionsCamperSignatureHeading">
                        Camper Signature
                     </div>
                     <div className="DayCampOptionsCamperSignatureDisclaimer">
                        I agree to abide by all camp rules and will assume full responsibility for my physical welfare and will not hold the Bill Rice
                        Ranch liable in case of sickness or accident.
                     </div>
                     <div className="DayCampOptionsSignatureFields">
                        <div className="DayCampOptionsCamperSignatureName">
                           {emptyCamperSignatureError === true &&
                              <div className="emptyCamperSignature">
                                 Camper Must Sign Their Name Below
                              </div>
                           }
                           <label>Camper's Signature</label>
                           <input
                              type="text"
                              value={camperSignature}
                              onChange={(event) => {
                                 setCamperSignature(event.target.value)
                                 setEmptyCamperSignatureError(false)
                              }}
                           />
                        </div>
                        <div className="DayCampOptionsCamperSignatureDate">
                           <label>Date<br></br>{currentDate}&nbsp;</label>
                           {setCamperSignatureDate(currentDate)}
                        </div>
                     </div>
                  </div>
               </div>
            </form>
            <div className="DayCampOptionsButtons">
                  <div className="DayCampOptionsPreviousButton">
                     <button className='prevButton' onClick={() => setSelectedPage(previousPage)}>
                        Previous
                     </button>
                  </div>
                  <div className="DayCampOptionsNextButton">
                     <div style={{ color: 'green', margin: '15px, 0', fontFamily: 'Sen' }}></div>
                     <button className="nextButton" onClick={() => ValidateDayCampOptions()}>
                        Next
                     </button>
                  </div>
               </div>
         </div>
   )
}
export default DayCampOptions